import {
  useAssignSettingBatch9SignUpModalSubtext,
  useSettingBatch9SignUpModalSubtext,
} from "@faire/retailer-visitor-shared/settings/useSettingBatch9SignUpModalSubtext";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { IFourVariantXP } from "@faire/web-api--source/indigofair/settings/IFourVariantXP";
import React, { useEffect } from "react";

export const NonFaireDirectSubtitle: React.FC = () => {
  const subtitleVariant = useSettingBatch9SignUpModalSubtext();

  const assignSetting = useAssignSettingBatch9SignUpModalSubtext();
  useEffect(() => {
    assignSetting();
  }, [assignSetting]);

  if (subtitleVariant === IFourVariantXP.Bucket.VARIANT_2) {
    return (
      <Typography align="center">
        <StrictLocalMsg
          defaultMessage="Join the 500K+ retailers already using Faire."
          description={{
            text: "Subtitle text for sign-up modal",
            img: "https://cdn.faire.com/fastly/b31874aa6f813e81a78864950787f4e37aef0abbcbe21cf80630ae3f5b408aac.png",
          }}
        />
      </Typography>
    );
  } else if (subtitleVariant === IFourVariantXP.Bucket.VARIANT_3) {
    return (
      <Typography align="center">
        <StrictLocalMsg
          defaultMessage="The best brands. The best prices. All in one place."
          description={{
            text: "Subtitle text for sign-up modal",
            img: "https://cdn.faire.com/fastly/ba5333b91c230ff95a866113d81a528fc2d17049fd5ee356095a956968e6057d.png",
          }}
        />
      </Typography>
    );
  } else if (subtitleVariant === IFourVariantXP.Bucket.VARIANT_4) {
    return (
      <Typography align="center">
        <StrictLocalMsg
          defaultMessage="Wholesale buying, personalized for you."
          description={{
            text: "Subtitle text for sign-up modal",
            img: "https://cdn.faire.com/fastly/1ac0ec0985f1bfc3402fcec5264732e8ab900afdf2b144abe12df5d4210c7bce.png",
          }}
        />
      </Typography>
    );
  }

  // Control shows nothing
  return null;
};
